import dxDataGrid from 'devextreme/ui/data_grid';
import { SummaryGroupItem, SummaryTotalItem } from 'devextreme/ui/data_grid';

import { TColumns } from 'types/columnDefs';

/* -------------------- */

export const groupingTexts = {
    groupByThisColumn: '',
    groupContinuedMessage: '',
    groupContinuesMessage: '',
    ungroup: '',
    ungroupAll: '',
};

export const summaryTexts = {
    avg: '{0}',
    count: '{0}',
    max: '{0}',
    min: '{0}',
    sum: '{0}'
};

/* -------------------- */

export const getSummaryGroupItems = (columns: TColumns) => {
    const groupItems: SummaryGroupItem[] = [];

    if (columns) {
        for (const column of columns.filter(c => c.groupSummary)) {
            groupItems.push({
                column: column.field,
                name: column.field,
                summaryType: column.groupSummary,
                alignByColumn: true,
                skipEmptyValues: true,
                showInGroupFooter: false,
                valueFormat: column.format
            });
        }
    }
    return groupItems;
};

export const getSummaryTotalItems = (columns: TColumns, totalCaption?: string) => {
    const totalItems: SummaryTotalItem[] = [];

    if (columns) {
        for (const column of columns) {
            if (column.totalSummary) {
                totalItems.push({
                    column: column.field,
                    name: column.field,
                    showInColumn: column.field,
                    summaryType: column.totalSummary,
                    valueFormat: column.format
                });
            }
        }

        if (totalItems.length) {
            totalItems.unshift({
                column: columns[1].field,
                customizeText: () => totalCaption || 'Grand Total'      // TODO localise
            });
        }
    }

    return totalItems;
};

export const expandGroupsToIndex = (dataGrid: dxDataGrid<unknown, unknown> | undefined) =>
    (groupIndex?: number) => {
        if (dataGrid) {
            const groups = dataGrid.getDataSource().group();
            const numGroups = Array.isArray(groups) ? groups.length : 1;

            for (let i = 0; i < (groupIndex ?? numGroups); i++) {
                dataGrid.expandAll(i);
            }
            dataGrid.collapseAll(groupIndex ?? numGroups);
        }
    };
